import { render } from "./package-tab.vue?vue&type=template&id=3e8ab70d&scoped=true&ts=true"
import script from "./package-tab.vue?vue&type=script&lang=ts"
export * from "./package-tab.vue?vue&type=script&lang=ts"

import "./package-tab.vue?vue&type=style&index=0&id=3e8ab70d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8ab70d"]])

export default __exports__